export const TwitterIcon = (props) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.0153 4.83121C15.0255 4.97334 15.0255 5.11549 15.0255 5.25762C15.0255 9.59262 11.726 14.5876 5.69557 14.5876C3.83769 14.5876 2.11182 14.0495 0.660034 13.1155C0.924003 13.1459 1.17778 13.1561 1.45191 13.1561C2.98488 13.1561 4.39607 12.6383 5.52297 11.7551C4.08135 11.7246 2.87322 10.7805 2.45697 9.48096C2.66003 9.5114 2.86307 9.53171 3.07628 9.53171C3.37069 9.53171 3.66513 9.49109 3.93922 9.42006C2.43669 9.11546 1.30975 7.79568 1.30975 6.20178V6.16118C1.74628 6.40484 2.25394 6.55712 2.79197 6.5774C1.90872 5.98856 1.33007 4.9835 1.33007 3.84643C1.33007 3.23731 1.49247 2.67893 1.77675 2.19162C3.39097 4.18146 5.81738 5.48093 8.53816 5.62309C8.48741 5.37943 8.45694 5.12565 8.45694 4.87184C8.45694 3.06471 9.91888 1.59265 11.7361 1.59265C12.6803 1.59265 13.5331 1.98859 14.1321 2.62818C14.8732 2.48606 15.5838 2.21193 16.2133 1.83631C15.9696 2.59775 15.4518 3.23734 14.7717 3.6434C15.4316 3.57237 16.0712 3.38959 16.66 3.13581C16.2133 3.78553 15.6549 4.36418 15.0153 4.83121Z"
        fill="currentColor"
      />
    </svg>
  );
};
